import React from 'react';
import { get, map, size } from 'lodash';
import cx from 'classnames';

import Icons from '@/icons';
import { ICONS } from '@/constants/icons.constants';
import { dashboardTypes } from '@/types';

import styles from './DashboardTable.module.scss';
import { MEDIA_URL } from '@/axios';

interface Prop {
  classname?: string;
  type?: 'up' | 'down';
  data: dashboardTypes.Dashboard;
}

const DashboardTable = (props: Prop) => {
  const { classname, type, data } = props;
  const likedSongs = get(data, 'topLikedSongs', []) as dashboardTypes.likeSong[];
  const dislikedSongs = get(data, 'topDislikedSongs', []) as dashboardTypes.dislikeSong[];

  return (
    <div className={cx(styles.DashboardTable, classname)}>
      <div className={styles.header}>
        <div className={styles.heading1}>
          <p className={styles.title}>
            {type === 'down' ? 'Most Disliked songs' : 'Most Liked songs'}
          </p>
          <Icons
            type={type === 'down' ? ICONS.DOWN_ARROW : ICONS.UP_ARROW}
            className={styles.upArrow}
          />
        </div>
        <div className={styles.header2}>
          <p className={styles.view}>Views</p>
          <p className={styles.like}>{type === 'down' ? 'Dislikes' : 'Likes'}</p>
        </div>
      </div>

      <>
        <div className={styles.rows}>
          {type === 'down' ? (
            <div>
              {size(dislikedSongs) === 0 ? (
                <div className={styles.DataNotFound}>
                  <Icons type={ICONS.NODATA} className={styles.notDataFound} />
                </div>
              ) : (
                map(dislikedSongs, (item, index) => (
                  <div key={item._id ?? `${index}`} className={cx(styles.row, { [styles.back]: index % 2 })}>
                    <div className={styles.heading1}>
                      <div className={styles.iconText}>
                        {item.thumbnail_img ? (
                          <img
                            src={`${MEDIA_URL}/${get(
                              item,
                              'thumbnail_img',
                              '',
                            )}`}
                            alt="thumbnail"
                            className={styles.image}
                          />
                        ) : (
                          <div className={styles.songName}>
                            {get(item, 'title', '?').toString().charAt(0)}
                          </div>
                        )}
                      </div>
                      <p className={styles.title}>{get(item, 'title', '-')}</p>
                    </div>
                    <div className={styles.header2}>
                      <p className={styles.view}>{get(item, 'total_views', 0)}</p>
                      <p className={styles.like}>{get(item, 'total_dislikes', 0)}</p>
                    </div>
                  </div>
                ))
              )}
            </div>
          ) : (
            <div>
              {size(likedSongs) === 0 ? (
                <div className={styles.DataNotFound}>
                  <Icons type={ICONS.NODATA} className={styles.notDataFound} />
                </div>
              ) : (
                map(likedSongs, (item, index) => (
                  <div key={item._id ?? `${index}`} className={cx(styles.row, { [styles.back]: index % 2 })}>
                    <div className={styles.heading1}>
                      <div className={styles.iconText}>
                        {item.thumbnail_img ? (
                          <img
                            src={`${MEDIA_URL}/${get(
                              item,
                              'thumbnail_img',
                              '',
                            )}`}
                            alt="thumbnail"
                            className={styles.image}
                          />
                        ) : (
                          <div className={styles.songName}>
                            {get(item, 'title', '?').toString().charAt(0)}
                          </div>
                        )}
                      </div>
                      <p className={styles.title}>{get(item, 'title', '-')}</p>
                    </div>
                    <div className={styles.header2}>
                      <p className={styles.view}>{get(item, 'total_views', 0)}</p>
                      <p className={styles.like}>{get(item, 'total_likes', 0)}</p>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </>
    </div>
  );
};

export default DashboardTable;
